export const PLATFORM: any = 'web';
